var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuickMsgWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "30px",
    viewBox: "0 0 38 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icQuickMsgWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A4-Copy",
    transform: "translate(-79.000000, -1497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icQuickMsgWhite",
    transform: "translate(79.000000, 1498.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58064516,14.85 C9.11217894,18.3011063 11.0798414,19.9980667 14.2586987,21.6816508 L14.2586987,27.9128565 C14.2586987,28.0729209 14.3453805,28.2215164 14.4845731,28.2976425 C14.548213,28.3327137 14.6184362,28.35 14.6881893,28.35 C14.7704822,28.35 14.8529318,28.3255665 14.9242523,28.2775306 L21.8003338,23.6453058 C22.0785621,23.6600989 22.3389212,23.6750582 22.6041395,23.6750582 C30.6827945,23.6750582 36.7741935,18.5860767 36.7741935,11.8379446 C36.7741935,5.08898149 30.6827945,0 22.6041395,0 C18.5650471,0 15.0226903,1.27220382 12.4899499,3.38811114 L18.6369946,3.38811114 L12.8709677,14.85 L8.58064516,14.85 Z",
    id: "Stroke-3",
    stroke: "#fff",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "3.67741935 7.25 3.67741935 6.25 14.7096774 6.25 14.7096774 7.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "0 9.95 0 8.95 11.0322581 8.95 11.0322581 9.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "3.67741935 12.65 3.67741935 11.65 9.80645161 11.65 9.80645161 12.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6129032,14 C18.6484249,14 17.8870968,13.1615374 17.8870968,12.15 C17.8870968,11.1384626 18.6484249,10.3 19.6129032,10.3 C20.5773816,10.3 21.3387097,11.1384626 21.3387097,12.15 C21.3387097,13.1615374 20.5773816,14 19.6129032,14 Z M19.6129032,13 C20.0024133,13 20.3387097,12.6296315 20.3387097,12.15 C20.3387097,11.6703685 20.0024133,11.3 19.6129032,11.3 C19.2233932,11.3 18.8870968,11.6703685 18.8870968,12.15 C18.8870968,12.6296315 19.2233932,13 19.6129032,13 Z",
    id: "Oval-10",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.516129,14 C23.5516507,14 22.7903226,13.1615374 22.7903226,12.15 C22.7903226,11.1384626 23.5516507,10.3 24.516129,10.3 C25.4806074,10.3 26.2419355,11.1384626 26.2419355,12.15 C26.2419355,13.1615374 25.4806074,14 24.516129,14 Z M24.516129,13 C24.9056391,13 25.2419355,12.6296315 25.2419355,12.15 C25.2419355,11.6703685 24.9056391,11.3 24.516129,11.3 C24.126619,11.3 23.7903226,11.6703685 23.7903226,12.15 C23.7903226,12.6296315 24.126619,13 24.516129,13 Z",
    id: "Oval-10",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4193548,14 C28.4548765,14 27.6935484,13.1615374 27.6935484,12.15 C27.6935484,11.1384626 28.4548765,10.3 29.4193548,10.3 C30.3838332,10.3 31.1451613,11.1384626 31.1451613,12.15 C31.1451613,13.1615374 30.3838332,14 29.4193548,14 Z M29.4193548,13 C29.8088649,13 30.1451613,12.6296315 30.1451613,12.15 C30.1451613,11.6703685 29.8088649,11.3 29.4193548,11.3 C29.0298448,11.3 28.6935484,11.6703685 28.6935484,12.15 C28.6935484,12.6296315 29.0298448,13 29.4193548,13 Z",
    id: "Oval-10",
    fill: "#fff",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuickMsgWhite);
export default __webpack_public_path__ + "static/media/icQuickMsgWhite.0be2f0a4973b92292aa03ba54738622a.svg";
export { ForwardRef as ReactComponent };